import { useEffect } from 'react'
import { Outlet, useNavigate } from 'react-router-dom'

import { useAppStore } from '@/stores/appStore'

import { ROUTER_PRIVATE_LINKS } from './config'

export function PublicRoute() {
  const isAuthenticated = useAppStore((state) => state.isAuthenticated)
  const navigate = useNavigate()

  useEffect(() => {
    if (isAuthenticated) {
      navigate(ROUTER_PRIVATE_LINKS.home.path)
    }
  }, [isAuthenticated, navigate])

  return <Outlet />
}
